// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { postRefundFeeEstimate } from 'services/RefundService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { RefundFeePayload } from 'types/refund'

export const useRefundFeeEstimateMutation = () => {
  return useMutation({
    mutationFn: postRefundFeeEstimate,
    onError: (error: BaseErrorResponse, data: RefundFeePayload) => {
      logSentryError('Error: useRefundFeeEstimateMutation', error, data)
    },
  })
}
